import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../utils/queryParams.js";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_GOAL_BY_TYPE_SUCCESS = "saga/FETCH_GOAL_BY_TYPE_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_UPDATE_GOAL_SUCCESS = "saga/FETCH_UPDATE_GOAL_SUCCESS";
export const FETCH_GOALS = "saga/FETCH_GOALS";
export const FETCH_ALL_GOALS_SUCCESS = "saga/FETCH_ALL_GOALS_SUCCESS";
export const FETCH_GOALS_FAILURE = "saga/FETCH_GOALS_FAILURE";
export const UPDATE_GOAL_AS_VALUE = "saga/UPDATE_GOAL_AS_VALUE";
export const UPDATE_GOAL = "saga/UPDATE_GOAL";
export const UPDATE_DATE = "saga/UPDATE_DATE";
export const UPDATE_VIEW = "saga/UPDATE_VIEW";
export const SET_TOP_GOALS_LOADING = "saga/SET_TOP_GOALS_LOADING";
export const SET_GOALS_LOADING = "saga/SET_GOALS_LOADING";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATE = "saga/SET_DATE";

const GOAL_TYPES = ["attendance", "revenue", "memberships", "retention", "daily_pulse"];

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateGoal: createAction(UPDATE_GOAL),
  updateGoalAsValue: createAction(UPDATE_GOAL_AS_VALUE),
  updateDate: createAction(UPDATE_DATE),
  updateView: createAction(UPDATE_VIEW)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_GOAL, updateGoal);
  yield takeLatest(UPDATE_GOAL_AS_VALUE, updateGoalAsValue);
  yield takeLatest([UPDATE_VIEW, UPDATE_DATE], fetchAllGoals);
}

export function* getCurrentUserData({ payload }) {
  const { short_url } = yield select((state) => state.commonReducer.commonProps);
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: { ...payload, short_url } });
  yield put({ type: SET_LOADING, payload: true });

  yield put({ type: SET_DATE, payload: payload.calendarEndDate });

  try {
    yield put({ type: SET_LOADING, payload: false });
    yield fetchAllGoals();
  } catch (error) {
    console.error(error);
  }
}

function* fetchAllGoals() {
  yield put({ type: SET_TOP_GOALS_LOADING, payload: true });
  const fetchAllGoalsSagas = GOAL_TYPES.map((goalType) => fetchGoalsByType(goalType));
  try {
    yield all(fetchAllGoalsSagas);
    yield put({ type: FETCH_ALL_GOALS_SUCCESS });
    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchGoalsByType(goal_type) {
  let params = yield getCommonApiParams();
  yield put({ type: SET_GOALS_LOADING, payload: { [goal_type]: true } });
  try {
    const { data } = yield call(axios.get, queryParams.apiVersion + "goals", {
      params: { ...params, goal_type }
    });

    yield put({ type: FETCH_GOAL_BY_TYPE_SUCCESS, payload: data });
    yield put({ type: SET_GOALS_LOADING, payload: { [goal_type]: false } });
  } catch (error) {
    console.error(error);
  }
}

function* updateGoal({ payload }) {
  yield put({ type: SET_TOP_GOALS_LOADING, payload: true });

  try {
    const { data } = yield call(
      axios.put,
      queryParams.apiVersion +
        "goals/" +
        payload.id +
        "?change=" +
        payload.value +
        "&active=" +
        payload.active +
        "&goal_type=" +
        payload.goal_type +
        "&use_expected_value=" +
        false
    );

    yield put({
      type: FETCH_UPDATE_GOAL_SUCCESS,
      payload: { [payload.goal_type]: data }
    });

    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateGoalAsValue({ payload }) {
  yield put({ type: SET_TOP_GOALS_LOADING, payload: true });

  try {
    const { data } = yield call(
      axios.put,
      queryParams.apiVersion +
        "goals/" +
        payload.id +
        "?expected_value=" +
        payload.value +
        "&active=" +
        payload.active +
        "&goal_type=" +
        payload.goal_type +
        "&use_expected_value=" +
        true
    );
    yield put({
      type: FETCH_UPDATE_GOAL_SUCCESS,
      payload: { [payload.goal_type]: data }
    });

    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const { selectedView, date } = yield select((state) => state.goals);
  return { organization_id, short_url, date, view: selectedView.id };
}
